module.exports = __webpack_public_path__ + "static/organicmintmain-15c1d1e1e4e4af0c83f221654a0f3b49.jpeg";